import React from 'react'
import BlurText from './Animations/BlurText'
import ShinyText from './Animations/ShinyText'
import AnimatedContent from './Animations/AnimatedContent'
import GradientText from './Animations/GradientText'
import SpotlightCard from './Animations/SpotlightCard'

export default function Toknomic() {
    return (
        <div className='md:mt-[8vw] mt-[15vw] relative tok'>
            <div className='md:w-[70%] w-[90%] mx-auto lg:pl-20 flex flex-col items-center justify-center'>
                <div className='bg-black md:px-5 py-1 rounded-3xl w-fit md:mb-5 mb-2'>
                    <GradientText
                        colors={["#40ffaa", "#BEFFCD", "#7358F9",]}
                        animationSpeed={3}
                        showBorder={false}
                        className="font-semibold md:text-lg text-sm "
                    >
                        TOKEN METRICS
                    </GradientText>
                </div>
                <BlurText
                    text="Our Tokenomics"
                    delay={300}
                    animateBy="words"
                    direction="top"
                    className="md:text-5xl text-3xl font-medium !text-center md:mb-5 mb-2"
                />
                <ShinyText text="CA: F4CRszGnLhwMRNXYsddV7aAXun9XTnbsYEGjTvdttUU2"
                    disabled={false} speed={3} className='md:text-2xl text-[10px] text-wrap font-normal text-center' />
            </div>
            <div className='grid md:grid-cols-3 grid-cols-1 gap-5 lg:w-[80%] w-[90%] mx-auto mt-10 '>
                <AnimatedContent
                    distance={150}
                    direction="horizontal"
                    reverse={false}
                    config={{ tension: 80, friction: 20 }}
                    initialOpacity={0.2}
                    animateOpacity
                    scale={1.1}
                    threshold={0.2}
                >
                    <img src="/images/tok-1.png" alt="" />
                </AnimatedContent>
                <AnimatedContent
                    distance={150}
                    direction="vertical"
                    reverse={false}
                    config={{ tension: 80, friction: 20 }}
                    initialOpacity={0.2}
                    animateOpacity
                    scale={1.1}
                    threshold={0.2}
                >
                    <img src="/images/tok-2.png" alt="" />
                </AnimatedContent>
                <AnimatedContent
                    distance={150}
                    direction="horizontal"
                    reverse={false}
                    config={{ tension: 80, friction: 20 }}
                    initialOpacity={0.2}
                    animateOpacity
                    scale={1.1}
                    threshold={0.2}
                >
                    <img src="/images/tok-3.png" alt="" />
                </AnimatedContent>
            </div>
        </div>
    )
}
